import * as React from 'react';
import {connect} from "react-redux";
import ContactTab from '../Tab/ContactTab';
import {Auth, CompanyHistory} from '../../../Config/dataModel';
import {CONTACT_TAB} from '../../../Config/appConfig';
import userManagementDispatch from '../../../ReduxRequests/Dispatch/userManagementDispatch';
import userManagementState from '../../../ReduxRequests/State/userManagementState';
import CloseButton from '../../Custom/CloseButton';
import authState from '../../../ReduxRequests/State/authState';
import Table from '../../Custom/Table';
import util from '../../../Util/util';

const mapStateToProps = (state) => {
    return {
        ...userManagementState(state),
        ...authState(state)
    }
};

interface InsurerListProps {
    auth?: () => Auth,
    fetchInsurerHistory?: () => void,
    insurerHistory?: CompanyHistory[]
}

interface InsurerListState {
    list: CompanyHistory[]
}

class InsurerList extends React.Component <InsurerListProps, InsurerListState> {
    public constructor(props: InsurerListProps) {
        super(props);
        this.state = {
            list: []
        };
    }

    public componentDidMount() {
        this.props.fetchInsurerHistory();
    }

    public componentWillReceiveProps(nextProps: InsurerListProps) {
        if (nextProps.insurerHistory !== this.props.insurerHistory) {
            this.setState({
                list: nextProps.insurerHistory
            });
        }
    }

    public getHeader() {
        return [
            {title: 'Insurance Company', cols: 7, sortable: false},
            {title: 'Relevant Date', cols: 4, sortable: false},
            {title: 'Insurer Code', cols: 1, sortable: false}
        ];
    }

    public getRows() {
        let rows = [];
        for (let i = 0; i < this.state.list.length; i++) {
            const data = this.state.list[i];
            rows.push([
                <span key={i} className={data.destroyTime ? "disabled cmObliqueText" : ""}>{data.displayName}</span>,
                <div key={i} className="contactTableViewCol">
                    <div className="contactTableViewCellLabel">{data.destroyTime ? "De-activated by" : "Invitation received on"}</div>
                    <div className={data.destroyTime ? " disabled cmObliqueText" : ""}>
                        {util.getFormattedDate(data.destroyTime ? data.destroyTime : data.createTime)}
                    </div>
                </div>,
                <span key={i} className={data.destroyTime ? "disabled cmObliqueText" : ""}>{data.destroyTime ? "" : data.shortId}</span>
            ]);
        }
        return rows;
    }

    public render() {
        return (
            <div className="cmHorCenter cmFormContainer">
                <div className="cmFormTitleHeader">
                    {this.props.auth().user.isAdmin ?
                        <ContactTab currentTab={CONTACT_TAB.COMPANY}/> :
                        <div className="cmFormTitle">View Insurer list</div>}
                    <CloseButton/>
                </div>
                <Table
                    header={this.getHeader()}
                    rows={this.getRows()}
                    clickable={false}
                    noRecords="No Insurance Companies are linked."/>
            </div>
        );
    }
}

export default connect(mapStateToProps, userManagementDispatch)(InsurerList);



// WEBPACK FOOTER //
// ./src/Components/Contact/CompanyList/InsurerList.tsx